// extracted by css-extract-rspack-plugin
export default {"cls1":"CreateSocialItemModal-cls1_F8f","cls2":"CreateSocialItemModal-cls2_bUi CreateSocialItemModal-cls1_F8f"};